import React from "react";
import brandsgallary from "../../Assets/Projects/brandsgallary.jpg";
import metric from "../../Assets/Projects/metric-conversion.jpg";
import easy from "../../Assets/Projects/easy-shift.jpg";
import iqra from "../../Assets/Projects/iqra-hospital.jpg";
import { useNavigate } from "react-router-dom";

const cardData = [
  {
    id: 1,
    title: "Iqra Hospital Data Management",
    image: iqra,
    desc: "Iqra Hospital System is a patient information management",
    link: "iqra-hospital-data-management",
    tech1: "Html",
    tech2: "CSS",
    tech3: "JS",
    tech4: "React",
    tech5: "Firebase",
    tech6: "Bootstrap",
    tech7: "Material UI",
  },
  {
    id: 2,
    title: "Metric Conversion",
    image: metric,
    desc: "Metric Conversion calculators and formulas for temperature, length, area, volume and weight",
    link: "metric-conversion",
    tech1: "Html",
    tech2: "CSS",
    tech3: "JS",
    tech4: "Bootstrap",
    tech5: "Github",
  },
  {
    id: 3,
    title: "Easy Shift | Shifting Solution",
    image: easy,
    desc: "A days shifting of the employees with their login credentials",
    link: "easy-shift-shifting-solution",
    tech1: "Html",
    tech2: "CSS",
    tech3: "JS",
    tech4: "React",
    tech5: "Firebase",
    tech6: "Bootstrap",
    tech7: "Material UI",
  },
  {
    id: 4,
    title: "Brands Gallary",
    image: brandsgallary,
    desc: "Brands Gallery, where fashion meets inspiration. We are a passionate community",
    link: "brands-gallary",
    tech1: "Html",
    tech2: "CSS",
    tech3: "JS",
    tech4: "Bootstrap",
    tech5: "Wordpress",
    tech6: "WooCommerce",
  },
];

const Project = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="container">
        <div className="row">
          {cardData.map((card, index) => (
            <div className="col-lg-3" key={index}>
              <div
                className="card shadow-box-2 bg-dark"
                style={{ height: "21.5rem", cursor: "pointer" }}
                onClick={() => navigate(`/projects/${card.link}`)}
              >
                <img src={card.image} className="card-img-top" alt="..." />
                <div className="card-body">
                  <h6 className="card-title">{card.title}</h6>
                  <p className="small-text">{card.desc}</p>
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech1}
                  </span>
                  &nbsp;
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech2}
                  </span>
                  &nbsp;
                  <span class="badge text-bg-secondary" data-aos="flip-right">
                    {card.tech3}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech4}
                  </span>{" "}
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech5}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech6}
                  </span>
                  &nbsp;
                  <span
                    class="badge text-bg-secondary mt-2"
                    data-aos="flip-right"
                  >
                    {card.tech7}
                  </span>
                  {/* <a href="#" className="btn btn-primary">
                    Go somewhere
                  </a> */}
                </div>
              </div>{" "}
              <br />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Project;
